interface Card {
  children: JSX.Element | JSX.Element[]
  className?: string
  id?: string
}

const Card = ({ children, className = '', id = null }) => (
  <div
    id={id}
    className={`rounded-lg outline outline-1 outline-offset-0 outline-gray-500 ${className}`}
  >
    {children}
  </div>
)

export default Card
